'use client';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledInput = styled(Box)(() => ({
  '& .MuiFormControl-root': {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  '& .MuiFilledInput-root': {
    height: '100%',
    borderRadius: '6px',
    backgroundColor: 'transparent !important',
  },
  '& .MuiFilledInput-underline:before, .MuiFilledInput-underline:after': {
    borderBottom: 'none !important',
    content: '""',
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  '& .MuiFilledInput-underline:hover:before': {
    borderBottom: 'none',
  },
  '& .MuiInputAdornment-root': {
    marginTop: '0px !important',
    marginRight: '6px !important',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    WebkitTextFillColor: 'unset !important',
  },
}));
